/*
 * @Author: your name
 * @Date: 2020-10-28 17:40:59
 * @LastEditTime: 2021-11-25 18:48:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ksh-factory-vue/src/utils/elmImport.js
 */
import Vue from "vue";
import {
  Collapse,
  CollapseItem,
  Card,
  Tabs,
  TabPane,
  Row,
  Col,
  Container,
  Header,
  Aside,
  Main,
  Menu,
  Submenu,
  MenuItem,
  Avatar,
  Link,
  Tag,
  Input,
  Loading,
  Empty,
  Button,
  Upload,
  Message,
  MessageBox,
  Notification,
  Dialog,
  Table,
  Pagination,
  TableColumn,
  DatePicker,
  Popconfirm,
  Popover,
  Divider,
  Select,
  Option,
  Image,
  Radio,
  RadioGroup,
  RadioButton,
  InputNumber,
  Tooltip,
  Scrollbar,
  Checkbox,
  Form,
  FormItem,
  CheckboxButton,
  CheckboxGroup,
  Tree,
  Progress,
  Steps,
  Alert,
  Step,
  Autocomplete,
  Switch,
  Drawer,
  Dropdown,
  DropdownItem,
  Breadcrumb,
  BreadcrumbItem,
  DropdownMenu,
  Carousel,
  CarouselItem,
} from "element-ui";
Vue.use(Collapse)
  .use(Alert)
  .use(CollapseItem)
  .use(Card)
  .use(Tabs)
  .use(TabPane)
  .use(Row)
  .use(Col)
  .use(Container)
  .use(Header)
  .use(Aside)
  .use(Main)
  .use(Container)
  .use(Menu)
  .use(Submenu)
  .use(MenuItem)
  .use(Link)
  .use(Tag)
  .use(Input)
  .use(InputNumber)
  .use(Loading.directive)
  .use(Button)
  .use(Upload)
  .use(Dialog)
  .use(Table)
  .use(TableColumn)
  .use(Pagination)
  .use(DatePicker)
  .use(Popconfirm)
  .use(Popover)
  .use(Divider)
  .use(Select)
  .use(Option)
  .use(Image)
  .use(Radio)
  .use(Form)
  .use(FormItem)
  .use(Tooltip)
  .use(RadioGroup)
  .use(RadioButton)
  .use(Scrollbar)
  .use(Checkbox)
  .use(CheckboxButton)
  .use(CheckboxGroup)
  .use(Tree)
  .use(Progress)
  .use(Autocomplete)
  .use(Steps)
  .use(Step)
  .use(Switch)
  .use(Drawer)
  .use(Dropdown)
  .use(DropdownItem)
  .use(DropdownMenu)
  .use(Avatar)
  .use(Breadcrumb)
  .use(BreadcrumbItem)
  .use(Carousel)
  .use(CarouselItem)
  .use(Empty)
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
